/**
 * Customization presets per category. Kept in TS (not the DB) because
 * they're UX defaults, not persistent data — admins can override these
 * via item.metadata in a follow-up.
 */

export interface CustomizerControl {
  key: string;
  label: string;
  options: ReadonlyArray<{ value: string; label: string }>;
}

const COFFEE_CONTROLS: CustomizerControl[] = [
  {
    key: 'milk',
    label: 'Milk',
    options: [
      { value: 'whole',    label: 'حليب كامل' },
      { value: 'oat',      label: 'حليب الشوفان' },
      { value: 'almond',   label: 'حليب اللوز' },
      { value: 'none',     label: 'بدون' },
    ],
  },
  {
    key: 'sweetness',
    label: 'Sweetness',
    options: [
      { value: 'none',     label: 'بدون سكر' },
      { value: 'less',     label: 'قليل' },
      { value: 'normal',   label: 'عادي' },
    ],
  },
  {
    key: 'temperature',
    label: 'Temperature',
    options: [
      { value: 'hot',      label: 'ساخن' },
      { value: 'iced',     label: 'مثلج' },
    ],
  },
];

const PASTRY_CONTROLS: CustomizerControl[] = [
  {
    key: 'warming',
    label: 'Warming',
    options: [
      { value: 'cold',     label: 'بارد' },
      { value: 'warmed',   label: 'مسخّن' },
    ],
  },
  {
    key: 'plating',
    label: 'Plating',
    options: [
      { value: 'classic',  label: 'كلاسيكي' },
      { value: 'rose',     label: 'مزيّن بالورد' },
      { value: 'pistachio',label: 'مزيّن بالفستق' },
    ],
  },
];

const FALLBACK_CONTROLS: CustomizerControl[] = [
  {
    key: 'plating',
    label: 'Plating',
    options: [
      { value: 'classic',  label: 'كلاسيكي' },
      { value: 'elegant',  label: 'أنيق' },
    ],
  },
];

export function controlsForCategory(slug: string): CustomizerControl[] {
  if (slug.includes('coffee') || slug.includes('drink') || slug.includes('seasonal')) {
    return COFFEE_CONTROLS;
  }
  if (slug.includes('pastry') || slug.includes('dessert')) {
    return PASTRY_CONTROLS;
  }
  return FALLBACK_CONTROLS;
}
